(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elaur-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elaur-gallery')) {
  customElements.define('elaur-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.elaur-gallery__track');
      const slides = track.children;
      const count = this.querySelector('.elaur-gallery__count');
      const position = () => Math.round(track.scrollLeft / track.clientWidth);
      const move = delta => {
        const next = (position() + delta + slides.length) % slides.length;
        track.scrollTo({left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const update = () => { count.textContent = (position() + 1) + ' / ' + slides.length; };
      this.querySelector('.elaur-gallery__previous').addEventListener('click', () => move(-1));
      this.querySelector('.elaur-gallery__next').addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      if (slides.length < 2) this.querySelectorAll('button').forEach(button => button.hidden = true);
      update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elaur-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.en-category details, details.elaur-locale';
  const close = except => document.querySelectorAll(selector).forEach(menu => {
    if (menu !== except) menu.open = false;
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const menu = target.closest(selector);
    close(menu);
    if (target.closest('a') && menu) menu.open = false;
    const sidebar = target.closest('header-sidebar');
    if (sidebar && target.closest('a')) {
      sidebar.shadowRoot?.querySelector('dialog-close-button button')?.click();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = [...document.querySelectorAll(selector)].find(item => item.open);
    if (!menu) return;
    close();
    menu.querySelector('summary')?.focus();
    event.preventDefault();
  });
  document.addEventListener('focusin', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest(selector)) close();
  });
  window.addEventListener('resize', () => close());
})();
  } catch(e) { console.error(e); }
})();

})();
